/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_TitleInputs */

const en_mk_proof_title = /** @type {(inputs: Mk_Proof_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proof, not claims`)
};

const id_mk_proof_title = /** @type {(inputs: Mk_Proof_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukti, bukan klaim`)
};

/**
* | output |
* | --- |
* | "Proof, not claims" |
*
* @param {Mk_Proof_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_title = /** @type {((inputs?: Mk_Proof_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_title(inputs)
	return en_mk_proof_title(inputs)
});